<template comments>
  <div>
    <div class="act-swiper-box">
      <!-- swiper 区域 S   -->
      <div class="act-swiper example-3d">
        <swiper
          ref="mySwiper"
          :options="swiperOption"
          @slideChange="slideChange"
          @click="playerVideo"
        >
          <swiper-slide v-for="(item, index) in randomGameInfo" :key="index">
            <div class="act-swiper-button" :data-id="item.videoId"></div>
            <div class="act-swiper-img">
              <img :src="item.image" alt="" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <!-- swiper 区域 E   -->

      <!-- 价格浮层 S   -->
      <div class="act-gameinfo">
        <div class="act-gameinfo-inner">
          <del class="old-price">
            原价：{{ randomGameInfo[activeIndex].originalPrice }}元
          </del>
          <span class="act-gameinfo-tips-txt">
            到手价
          </span>
          <div class="act-gameinfo-tips">
            <p class="act-gameinfo-title">
              <strong>{{ randomGameInfo[activeIndex].name }}</strong>
            </p>
            <div class="act-gameinfo-price">
              <span class="price-unit">¥</span>
              <span class="price-val">{{
                randomGameInfo[activeIndex].discountPrice
              }}</span>
              <!-- <span class="price-cnunit">元</span> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 价格浮层 E   -->
      <div class="btn-estore">
        <div class="btn-estore-item" @click="showPopbox">
          前往国行e商店购买
        </div>
      </div>
    </div>
    <!-- 视频弹窗 S -->
    <video-popbox
      :show.sync="showVideoPopbox"
      :video-id="videoId"
    ></video-popbox>
    <!-- 视频弹窗 E -->
  </div>
</template>

<script>
import { randomGameArr } from '@/libs/utils';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import VideoPopbox from '@/components/video-popbox';
import { SWIPER_GAME_INFO } from '@/libs/constant';
import { pgvEventReport } from '@/libs/tcss-report';
export default {
  components: {
    Swiper,
    SwiperSlide,
    VideoPopbox
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,
        // freeMode: true,
        autoplay: {
          delay: 1500 // 自动播放间隔时间
        },
        coverflowEffect: {
          rotate: 0,
          stretch: -80,
          depth: 600,
          modifier: -1,
          slideShadows: false
        }
      },
      randomGameInfo: [],
      gameInfo: SWIPER_GAME_INFO,
      activeIndex: 0,
      swiperNumber: 5,
      videoId: '',
      showVideoPopbox: false // 视频弹窗
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  created() {
    this.randomGameArr();
  },
  methods: {
    randomGameArr() {
      const gameInfo = JSON.parse(JSON.stringify(this.gameInfo));
      this.randomGameInfo = randomGameArr(gameInfo, this.swiperNumber);
    },
    slideChange() {
      this.activeIndex = this.swiper.activeIndex % this.swiperNumber;
    },
    showPopbox() {
      pgvEventReport('anniversary.activity.coupons.eshopBtn');
      this.$emit('update:show', true);
    },
    playerVideo(event) {
      // 点击播放区域
      if (event.target && event.target.className === 'act-swiper-button') {
        const videoId = event.target.getAttribute('data-id');
        pgvEventReport(`anniversary.activity.video.${videoId}`);
        this.videoId = videoId;
        this.showVideoPopbox = true;
      }
    }
  }
};
</script>
